"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsByDefinition = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var HeightSetting_1 = require("./HeightSetting");
var ToggleSwitch_1 = require("./ToggleSwitch");
/**
 * @internal
 */
exports.OptionsByDefinition = function (props) {
    var option = props.option, onChange = props.onChange;
    var intl = react_intl_1.useIntl();
    return (react_1.default.createElement("div", { className: "embed-insight-dialog-lang-selector" },
        react_1.default.createElement("strong", { className: "bottom-space top-space" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "embedInsightDialog.code.options" })),
        react_1.default.createElement(ToggleSwitch_1.ToggleSwitch, { id: "include-configuration", className: "bottom-space", label: intl.formatMessage({
                id: "embedInsightDialog.code.options.include.config",
            }), questionMarkMessage: intl.formatMessage({
                id: "embedInsightDialog.code.options.include.config.info",
            }), checked: option.includeConfiguration, onChange: function () {
                var opt = tslib_1.__assign(tslib_1.__assign({}, option), { includeConfiguration: !option.includeConfiguration });
                onChange(opt);
            } }),
        react_1.default.createElement(ToggleSwitch_1.ToggleSwitch, { id: "custom-height", label: intl.formatMessage({
                id: "embedInsightDialog.code.options.custom.height",
            }), checked: option.customHeight, onChange: function () {
                var opt = tslib_1.__assign(tslib_1.__assign({}, option), { customHeight: !option.customHeight });
                onChange(opt);
            } }),
        option.customHeight ? (react_1.default.createElement(HeightSetting_1.HeightSetting, { value: option.height, unit: option.unit, onValueChange: function (height, unit) {
                var opt = tslib_1.__assign(tslib_1.__assign({}, option), { height: height, unit: unit });
                onChange(opt);
            } })) : null));
};
//# sourceMappingURL=OptionsByDefinition.js.map